$searchInput = $(".js-search_input");
$search = $(".js-search");
$searchList = $(".js-search_list");

changeSearch = null;

$searchInput.on("keydown", function(e){
    clearTimeout(changeSearch);
});

$searchInput.on("keyup", function(e){
    var currentElement = this;
    var value = $(currentElement).val();

    changeSearch = window.setTimeout(function(){
        $searchInput.not(currentElement).val(value)
        fillSearchPreview($(currentElement), value);
    }, 500)
});

$searchInput.on("keydown", function(e){
    var $currentElement = $(this);

    if(e.keyCode === 13){
        e.preventDefault();
        search($currentElement);
    }
});

$search.on("click keydown", function(e){
    if(e.type !== 'click' &&  e.key === " "){
        e.preventDefault();
        e.stopPropagation();
        return;
    }
    if(e.type === 'keydown' && e.key !== "Enter") return;
    var $currentElement = $(this);

    search($currentElement.siblings(".js-search_input"));
});


toggleSearchList = null;
$(document).on("mouseenter", ".js-search_list", function(e){
    e.preventDefault();
    $searchList.show(0);
    clearTimeout(toggleSearchList);
}).on("mouseleave", ".js-search_list", function(){
    if($searchInput.not(":focus")){
        toggleSearchList = window.setTimeout(function(){
            hideSearchPreview();
        }, 500)
    }
})

$(document).on("focus", ".js-search_input", function(e){
    e.preventDefault();
    var $currentElement = $(this);
    if($searchList.html() == "" && $currentElement.val().length >= 2){
        fillSearchPreview($currentElement, $currentElement.val())
    }else{
        showSearchPreview();
    }
    clearTimeout(toggleSearchList);
}).on("click", ".js-search_input", function(e){
    e.preventDefault();
    var $currentElement = $(this);
    if($searchList.html() == "" && $currentElement.val().length >= 2){
        fillSearchPreview($currentElement, $currentElement.val())
    }else{
        showSearchPreview();
    }
    clearTimeout(toggleSearchList);
}).on("blur", ".js-search_input", function(){
    toggleSearchList = window.setTimeout(function(){
        hideSearchPreview();
    }, 500)
})

function search($currentElement){
    var search = $currentElement.val();
    var href = $searchInput.data("page")
    document.location.href = href + "?s=" + encodeURIComponent(search);
}

function fillSearchPreview($currentElement, searchValue){
    if(searchValue.length >= 2){
        $.ajax({
            url:root + "cmshx_template/ajax/ecprod_get_search_preview.php",
            data:{s:searchValue,
                  csrf_token:csrf_token
            },
            type:"POST",
            dataType:"html",
        }).done(function(html){
            $currentElement.parent().append($searchList)
            $searchList.html(html);
            if(html != "") showSearchPreview();
        });
    }else{
        hideSearchPreview();
    }
}

function showSearchPreview(){
    $searchList.slideDown();
}


function hideSearchPreview(){
    $searchList.slideUp();
}
